import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { FieldType, FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from 'primeng/inputtext';
import * as ɵngcc4 from '@ngx-formly/core';
import * as ɵngcc5 from 'primeng/checkbox';
import * as ɵngcc6 from 'primeng/radiobutton';
import * as ɵngcc7 from '@ngx-formly/core/select';
import * as ɵngcc8 from 'primeng/dropdown';
import * as ɵngcc9 from 'primeng/inputtextarea';

function FormlyFieldInput_input_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ng-dirty", ctx_r0.showError);
    ɵngcc0.ɵɵproperty("type", ctx_r0.to.type || "text")("formControl", ctx_r0.formControl)("formlyAttributes", ctx_r0.field);
} }
function FormlyFieldInput_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ng-dirty", ctx_r2.showError);
    ɵngcc0.ɵɵproperty("formControl", ctx_r2.formControl)("formlyAttributes", ctx_r2.field);
} }
function FormlyFieldRadio_p_radioButton_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-radioButton", 1);
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ng-dirty", ctx_r0.showError);
    ɵngcc0.ɵɵproperty("name", ctx_r0.field.name || ctx_r0.id)("formControl", ctx_r0.formControl)("label", option_r1.label)("value", option_r1.value);
} }
function FormlyWrapperFormField_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function FormlyWrapperFormField_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3)(1, "label", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, FormlyWrapperFormField_div_0_span_3_Template, 2, 0, "span", 5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.to.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.to.required && ctx_r0.to.hideRequiredMarker !== true);
} }
function FormlyWrapperFormField_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "formly-validation-message", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r2.field);
} }
class FormlyFieldInput extends FieldType {
}
FormlyFieldInput.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldInput_BaseFactory; return function FormlyFieldInput_Factory(t) { return (ɵFormlyFieldInput_BaseFactory || (ɵFormlyFieldInput_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldInput)))(t || FormlyFieldInput); }; }();
FormlyFieldInput.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldInput, selectors: [["formly-field-primeng-input"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["pInputText", "", 3, "type", "formControl", "formlyAttributes", "ng-dirty", 4, "ngIf", "ngIfElse"], ["numberTmp", ""], ["pInputText", "", 3, "type", "formControl", "formlyAttributes"], ["type", "number", "pInputText", "", 3, "formControl", "formlyAttributes"]], template: function FormlyFieldInput_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormlyFieldInput_input_0_Template, 1, 5, "input", 0);
        ɵngcc0.ɵɵtemplate(1, FormlyFieldInput_ng_template_1_Template, 1, 4, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.to.type !== "number")("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc3.InputText, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc4.FormlyAttributes, ɵngcc2.NumberValueAccessor], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldInput, [{
        type: Component,
        args: [{
                selector: 'formly-field-primeng-input',
                template: `
    <input *ngIf="to.type !== 'number' else numberTmp" pInputText [type]="to.type || 'text'" [formControl]="formControl" [formlyAttributes]="field" [class.ng-dirty]="showError">
    <ng-template #numberTmp>
      <input type="number" pInputText [formControl]="formControl" [formlyAttributes]="field" [class.ng-dirty]="showError">
    </ng-template>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldCheckbox extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            templateOptions: {
                hideLabel: true,
            },
        };
    }
}
FormlyFieldCheckbox.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldCheckbox_BaseFactory; return function FormlyFieldCheckbox_Factory(t) { return (ɵFormlyFieldCheckbox_BaseFactory || (ɵFormlyFieldCheckbox_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldCheckbox)))(t || FormlyFieldCheckbox); }; }();
FormlyFieldCheckbox.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldCheckbox, selectors: [["formly-field-primeng-checkbox"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 5, consts: [["binary", "true", 3, "label", "formControl", "formlyAttributes", "onChange"]], template: function FormlyFieldCheckbox_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-checkbox", 0);
        ɵngcc0.ɵɵlistener("onChange", function FormlyFieldCheckbox_Template_p_checkbox_onChange_0_listener($event) { return ctx.to.change && ctx.to.change(ctx.field, $event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ng-dirty", ctx.showError);
        ɵngcc0.ɵɵproperty("label", ctx.to.label)("formControl", ctx.formControl)("formlyAttributes", ctx.field);
    } }, directives: [ɵngcc5.Checkbox, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc4.FormlyAttributes], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldCheckbox, [{
        type: Component,
        args: [{
                selector: 'formly-field-primeng-checkbox',
                template: `
    <p-checkbox
      [class.ng-dirty]="showError"
      binary="true"
      [label]="to.label"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (onChange)="to.change && to.change(field, $event)">
    </p-checkbox>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldRadio extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            templateOptions: { options: [] },
        };
    }
}
FormlyFieldRadio.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldRadio_BaseFactory; return function FormlyFieldRadio_Factory(t) { return (ɵFormlyFieldRadio_BaseFactory || (ɵFormlyFieldRadio_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldRadio)))(t || FormlyFieldRadio); }; }();
FormlyFieldRadio.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldRadio, selectors: [["formly-field-primeng-radio"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [[3, "ng-dirty", "name", "formControl", "label", "value", 4, "ngFor", "ngForOf"], [3, "name", "formControl", "label", "value"]], template: function FormlyFieldRadio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormlyFieldRadio_p_radioButton_0_Template, 1, 6, "p-radioButton", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵpipe(2, "formlySelectOptions");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(1, 1, ɵngcc0.ɵɵpipeBind2(2, 3, ctx.to.options, ctx.field)));
    } }, directives: [ɵngcc1.NgForOf, ɵngcc6.RadioButton, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective], pipes: [ɵngcc1.AsyncPipe, ɵngcc7.FormlySelectOptionsPipe], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldRadio, [{
        type: Component,
        args: [{
                selector: 'formly-field-primeng-radio',
                template: `
    <p-radioButton *ngFor="let option of to.options | formlySelectOptions:field | async"
      [class.ng-dirty]="showError"
      [name]="field.name || id"
      [formControl]="formControl"
      [label]="option.label"
      [value]="option.value">
    </p-radioButton>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldSelect extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            templateOptions: { options: [] },
        };
    }
}
FormlyFieldSelect.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldSelect_BaseFactory; return function FormlyFieldSelect_Factory(t) { return (ɵFormlyFieldSelect_BaseFactory || (ɵFormlyFieldSelect_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldSelect)))(t || FormlyFieldSelect); }; }();
FormlyFieldSelect.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldSelect, selectors: [["formly-field-primeng-select"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 12, consts: [[3, "placeholder", "options", "formControl", "formlyAttributes", "showClear", "onChange"]], template: function FormlyFieldSelect_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dropdown", 0);
        ɵngcc0.ɵɵlistener("onChange", function FormlyFieldSelect_Template_p_dropdown_onChange_0_listener($event) { return ctx.to.change && ctx.to.change(ctx.field, $event); });
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵpipe(2, "formlySelectOptions");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ng-dirty", ctx.showError);
        ɵngcc0.ɵɵproperty("placeholder", ctx.to.placeholder)("options", ɵngcc0.ɵɵpipeBind1(1, 7, ɵngcc0.ɵɵpipeBind2(2, 9, ctx.to.options, ctx.field)))("formControl", ctx.formControl)("formlyAttributes", ctx.field)("showClear", !ctx.to.required);
    } }, directives: [ɵngcc8.Dropdown, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc4.FormlyAttributes], pipes: [ɵngcc1.AsyncPipe, ɵngcc7.FormlySelectOptionsPipe], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldSelect, [{
        type: Component,
        args: [{
                selector: 'formly-field-primeng-select',
                template: `
    <p-dropdown
      [class.ng-dirty]="showError"
      [placeholder]="to.placeholder"
      [options]="to.options | formlySelectOptions:field | async"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [showClear]="!to.required"
      (onChange)="to.change && to.change(field, $event)">
    </p-dropdown>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldTextArea extends FieldType {
}
FormlyFieldTextArea.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldTextArea_BaseFactory; return function FormlyFieldTextArea_Factory(t) { return (ɵFormlyFieldTextArea_BaseFactory || (ɵFormlyFieldTextArea_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldTextArea)))(t || FormlyFieldTextArea); }; }();
FormlyFieldTextArea.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldTextArea, selectors: [["formly-field-primeng-textarea"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 6, consts: [["pInputTextarea", "", 3, "formControl", "formlyAttributes", "cols", "rows"]], template: function FormlyFieldTextArea_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "textarea", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ng-dirty", ctx.showError);
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl)("formlyAttributes", ctx.field)("cols", ctx.to.cols)("rows", ctx.to.rows);
    } }, directives: [ɵngcc2.DefaultValueAccessor, ɵngcc9.InputTextarea, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc4.FormlyAttributes], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldTextArea, [{
        type: Component,
        args: [{
                selector: 'formly-field-primeng-textarea',
                template: `
    <textarea
      [class.ng-dirty]="showError"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [cols]="to.cols"
      [rows]="to.rows"
      pInputTextarea
    ></textarea>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyWrapperFormField extends FieldWrapper {
}
FormlyWrapperFormField.ɵfac = /*@__PURE__*/ function () { let ɵFormlyWrapperFormField_BaseFactory; return function FormlyWrapperFormField_Factory(t) { return (ɵFormlyWrapperFormField_BaseFactory || (ɵFormlyWrapperFormField_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyWrapperFormField)))(t || FormlyWrapperFormField); }; }();
FormlyWrapperFormField.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyWrapperFormField, selectors: [["formly-wrapper-primeng-form-field"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [["class", "ui-widget", 4, "ngIf"], ["fieldComponent", ""], ["class", "ui-message ui-widget ui-corner-all ui-message-error ui-messages-error", 4, "ngIf"], [1, "ui-widget"], [3, "for"], ["aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true"], [1, "ui-message", "ui-widget", "ui-corner-all", "ui-message-error", "ui-messages-error"], [1, "ui-message-text", 3, "field"]], template: function FormlyWrapperFormField_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormlyWrapperFormField_div_0_Template, 4, 3, "div", 0);
        ɵngcc0.ɵɵelementContainer(1, null, 1);
        ɵngcc0.ɵɵtemplate(3, FormlyWrapperFormField_div_3_Template, 2, 1, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.to.label && ctx.to.hideLabel !== true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.ɵc], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyWrapperFormField, [{
        type: Component,
        args: [{
                selector: 'formly-wrapper-primeng-form-field',
                template: `
    <div *ngIf="to.label && to.hideLabel !== true" class="ui-widget">
      <label [for]="id">
        {{ to.label }}
        <span *ngIf="to.required && to.hideRequiredMarker !== true" aria-hidden="true">*</span>
      </label>
    </div>
    <ng-container #fieldComponent></ng-container>

    <div class="ui-message ui-widget ui-corner-all ui-message-error ui-messages-error" *ngIf="showError">
        <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
    </div>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FIELD_TYPE_COMPONENTS = [
    // types
    FormlyFieldInput,
    FormlyFieldTextArea,
    FormlyFieldCheckbox,
    FormlyFieldRadio,
    FormlyFieldSelect,
    // wrappers
    FormlyWrapperFormField,
];
/** @type {?} */
const PRIME_NG_FORMLY_CONFIG = {
    types: [
        {
            name: 'input',
            component: FormlyFieldInput,
            wrappers: ['form-field'],
        },
        {
            name: 'checkbox',
            component: FormlyFieldCheckbox,
            wrappers: ['form-field'],
        },
        {
            name: 'textarea',
            component: FormlyFieldTextArea,
            wrappers: ['form-field'],
        },
        {
            name: 'radio',
            component: FormlyFieldRadio,
            wrappers: ['form-field'],
        },
        {
            name: 'select',
            component: FormlyFieldSelect,
            wrappers: ['form-field'],
        },
    ],
    wrappers: [
        { name: 'form-field', component: FormlyWrapperFormField },
    ],
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyPrimeNGModule {
}
FormlyPrimeNGModule.ɵfac = function FormlyPrimeNGModule_Factory(t) { return new (t || FormlyPrimeNGModule)(); };
FormlyPrimeNGModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormlyPrimeNGModule });
FormlyPrimeNGModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            InputTextModule,
            InputTextareaModule,
            CheckboxModule,
            RadioButtonModule,
            DropdownModule,
            ReactiveFormsModule,
            FormlySelectModule,
            FormlyModule.forChild(PRIME_NG_FORMLY_CONFIG),
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyPrimeNGModule, [{
        type: NgModule,
        args: [{
                declarations: FIELD_TYPE_COMPONENTS,
                imports: [
                    CommonModule,
                    InputTextModule,
                    InputTextareaModule,
                    CheckboxModule,
                    RadioButtonModule,
                    DropdownModule,
                    ReactiveFormsModule,
                    FormlySelectModule,
                    FormlyModule.forChild(PRIME_NG_FORMLY_CONFIG),
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyPrimeNGModule, { declarations: function () { return [FormlyFieldInput, FormlyFieldTextArea, FormlyFieldCheckbox, FormlyFieldRadio, FormlyFieldSelect, FormlyWrapperFormField]; }, imports: function () { return [CommonModule,
        InputTextModule,
        InputTextareaModule,
        CheckboxModule,
        RadioButtonModule,
        DropdownModule,
        ReactiveFormsModule,
        FormlySelectModule, ɵngcc4.FormlyModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FormlyPrimeNGModule, FormlyFieldInput, FormlyFieldCheckbox, FormlyFieldRadio, FormlyFieldSelect, FormlyFieldTextArea, FormlyWrapperFormField, FIELD_TYPE_COMPONENTS as ɵa, PRIME_NG_FORMLY_CONFIG as ɵb };

